import { scaleLinear } from 'd3-scale';

function createBarPlot(el) {
    const rating = el.dataset.ratingBarPlot;
    const line1 = el.querySelector('.supplier-profile-rating__line1');
    const line2 = el.querySelector('.supplier-profile-rating__line2');
    const lineStart = 36.4995;
    const lineEnd = 140.18;
    const lineHeight = 11.4665;

    // Background Line
    line1.setAttribute('x1', lineStart);
    line1.setAttribute('x2', lineEnd);
    line1.setAttribute('y1', lineHeight);
    line1.setAttribute('y2', lineHeight);

    // Rating Line
    const scaleX = scaleLinear().domain([0, 5]).range([lineStart, lineEnd]);
    line2.setAttribute('x1', lineStart);
    line2.setAttribute('x2', scaleX(rating));
    line2.setAttribute('y1', lineHeight);
    line2.setAttribute('y2', lineHeight);
}

window.addEventListener(
    'DOMContentLoaded',
    () => {
        document.querySelectorAll('[data-rating-bar-plot]').forEach((el) => {
            createBarPlot(el);
        });
    },
);
